// extracted by mini-css-extract-plugin
module.exports = {"contactsListItem":"contactList_contactsListItem__3RWsM","deleteButton":"contactList_deleteButton__TZQn8","contactInfo":"contactList_contactInfo__2wSoi"};